import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';

const propTypes = {
  bsSize: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

const defaultProps = {
  bsSize: 'lg',
  value: 'placeholder',
  onChange: undefined,
};

const InputDay = ({ bsSize, value, onChange }) => (
  <Input type="select" bsSize={bsSize} value={value} onChange={onChange}>
    <option value="placeholder" disabled>
      Day
    </option>
    <option value="sunday">Sunday</option>
    <option value="monday">Monday</option>
    <option value="tuesday">Tuesday</option>
    <option value="wednesday">Wednesday</option>
    <option value="thursday">Thursday</option>
    <option value="friday">Friday</option>
    <option value="saturday">Saturday</option>
  </Input>
);

InputDay.propTypes = propTypes;
InputDay.defaultProps = defaultProps;

export { InputDay };



// WEBPACK FOOTER //
// ./src/business/register/components/input-day.js